module.exports = "https://web-assets.ifttt.com/packs/media/partners/icon-avatar-8ee16618.svg";